export default "__VITE_ASSET__BKAmirJl__"